module.exports = __webpack_public_path__ + "static/img/nodata.8468dc19.png";